import React, {Component} from 'react';

import Form from '../../../../components/form/ui-semantic-form';
import FormElement from '../../../../components/form/ui-semantic-form-elements';

export default class AddGroupProducts extends Component {

	closeModal() {
		this.props.removeModal();
	}

	submit() {
		this.props.forceSubmit().then(function(response){
			this.closeModal()
		}.bind(this))
	}

  render() {
    return (
      <div>
					<div style={{fontSize: '20px', textAlign: 'center', lineHeight: '26px'}} dangerouslySetInnerHTML={{__html: this.props.content}} />

					<div style={{textAlign: 'center', fontSize: '18px', marginTop: '25px'}}>Czy mimo to chcesz zamówienie na wybraną godzinę?</div>

					<div style={{display: 'flex', width: '100%', marginTop : '20px', justifyContent: 'center'}}>
						<div className="ui button green" onClick={this.submit.bind(this)}>TAK</div>
						<div className="ui button red" onClick={this.closeModal.bind(this)}>NIE</div>
					</div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./js/views/customer/order/modals/OverlapProduction.js
 **/